import styled from 'styled-components';

const Button = styled.button`
    color: #fef;
    background-color: #a68;
    font-size: 1rem;
    border: none;
    padding: 0.75rem;
    margin: 0 1rem;
    border-radius: 0.5rem;
    text-decoration: none;
    cursor: pointer;

    &:hover {
        background-color: #b79;
    }
`;

export default Button;
